// Dùng cho datepicker
export const  FormatDatesConfigVariables = {
  defaultFormatValue : 'YYYY-MM-DD HH:mm:ss',
  defaultFormatLocale : 'vi',
  currentFormatStorageKey: "currentFormatStorageKey"
}
